import moment from 'moment';
import sortBy from 'lodash/sortBy';
import { roundOff } from '../../lib/utils';

const sortBookingsToOldest = arr => sortBy(arr, ['bookingDate']);

const formatDate = date => moment(date).format('Do MMM');

const getHoursSinceBooking = startDate => {
  const now = moment(new Date()),
    end = moment(startDate),
    duration = moment.duration(now.diff(end)),
    hours = roundOff(duration.asHours(), 0);

  return hours;
};

const getDaysBetween = (startDate, endDate) => {
  const start = moment(startDate),
    end = moment(endDate),
    duration = moment.duration(end.diff(start)),
    days = roundOff(duration.asDays(), 0);

  return days;
};

const formatDateWithDays = date => moment(date).format('Do MMM ddd');

// When you don't specify the format and it's not ISO, what Moment does is pass the string to the
// native Date constructor, whose behavior varies browser to browser (and additionally,
// we've deprecated that fallback in the latest version of Moment because of this kind of inconsistency)
const formatDateWithDaysForFlights = date =>
  moment(date, 'Do MMM ddd').format('Do MMM ddd');

export {
  getHoursSinceBooking,
  sortBookingsToOldest,
  formatDateWithDays,
  getDaysBetween,
  formatDate,
  formatDateWithDaysForFlights,
};



// WEBPACK FOOTER //
// ./src/screens/BookingsDashboard/utils.js